<template>
	<div class="subject-audit-detail">
		<div class="container-fluid">
			<!-- Begin page -->
			<div class="wrapper">
				<div class="content-page content-subProject">
					<div class="content">
						<div class="row">
							<div class="col-12">
								<div class="page-title-box">
									<div class="page-title-right">
										<Breadcrumb/>
									</div>
									<h3 class="header-title mb-3">学校审核详情</h3>
								</div>
								<!-- end page-title-box -->
							</div>
						</div>

						<div class="row">
							<div class="col-12">
								<div class="card">
									<div class="card-body">
										
										
										<div class="card-reviewDetails">
											<h3 class="text-center">{{topicInfo.name}}</h3>
											<div class="row row-reviewDetails">
												<div class="col-6 col-md-3">负责人姓名：{{getAllEmcee}}</div>
												<div class="col-6 col-md-3">申报单位：{{topicInfo.unitName}}</div>
												<div class="col-6 col-md-3">学段：{{topicInfo.learningTypeName}}</div>
												<div class="col-6 col-md-3">领域：{{topicInfo.researchFieName}}</div>
												<div class="col-6 col-md-3">预结题时间：{{topicInfo.expectedClosingTime|getTime}}</div>
												<div class="col-6 col-md-3">学科：{{topicInfo.disciplineName}}</div>
												<div class="col-6 col-md-3">专业技术职务：{{topicInfo.professionalSkillPostName}}</div>
												<div class="col-6 col-md-3">学历：{{topicInfo.lastDegreeId}}</div>
												<div class="col-6 col-md-3">学位：{{topicInfo.lastQualificationId}}</div>
												<div class="col-6 col-md-3">研究专长：{{topicInfo.areasSpecialization}}</div>
												<div class="col-6 col-md-3">出生日期：{{topicInfo.birthTime|getTime}}</div>
												<div class="col-6 col-md-3">行政职务：{{topicInfo.administrativeDuties}}</div>
												<div class="col-12">核心成员：{{topicInfo.coreMember|getMember}}</div>
											</div>
											<!-- 审核文件列表 -->
											<ul class="file-list">
												<li class="file-item" :class="{active:curFileTitleIndex === index}" v-for="(item,index) in fileTitleList" :key="index" @click="changeFileTitle(index)">
													{{item}}
												</li>
											</ul>

											<!-- 在线浏览文档 -->
											<div class="view">
												<iframe ref="myIframe" height="100%" width="100%"></iframe>
											</div>

											<!-- 审核意见列表 -->
											<div class="comments-list" v-if="topicInfo.schoolAuditList">
												
												<div class="form-group row mb-2" v-for="(item,index) in topicInfo.schoolAuditList" :key="index">
													<label class="col-md-2 col-12 col-form-label" style="text-align: right;">{{item.auditType==1?'区级审核'+(index+1):'学校审核'+(index+1)}}</label>
													<div class="col-md-9 col-10">
														<table class="table table-bordered table-centered mb-0">
															<tbody>
																<tr>
																	<th>审核意见</th>
																	<td>{{item.auditState==2?'不通过':item.auditState==1?'通过':'退回修改'}}</td>
																	<th>审核人</th>
																	<td>{{item.auditName}}</td>
																	<th>审核时间</th>
																	<td>{{item.createTime|getTime}}</td>
																</tr>
																<tr>
																	<th>审核说明</th>
																	<td colspan="5">{{item.auditExplain}}</td>
																</tr>
															</tbody>
														</table>
													</div>
													<div class="col-md-1 col-2"><span class="required"></span></div>
												</div>
												
											</div>

											<!-- 表单 -->
											<el-form :model="auditForm" :rules="auditFormRules" ref="auditFormRef" label-width="100px">
												<el-form-item label="审核意见" prop="auditState">
													 <el-radio-group v-model="auditForm.auditState" @change="auditStateChange">
													    <el-radio :disabled="!topicInfo.mark" :label="0">退回修改</el-radio>
													    <el-radio :disabled="!topicInfo.mark" :label="1">通过</el-radio>
													    <!-- <el-radio  :label="2">不通过<span style="color:red">（不允许再修改）</span></el-radio> -->
													  </el-radio-group>
												</el-form-item>
												<el-form-item label="审核说明" prop="auditExplain" :rules="auditExplainRule">
													<el-input v-model="auditForm.auditExplain" type="textarea" autosize></el-input>
												</el-form-item>
											</el-form>

											<div class="text-center">
												<button type="button" class="btn btn-info" @click="submitAudit">确定</button>
												<button type="button" class="btn btn-light" style="margin-left: 20px;" @click="goBack">关 闭</button>
											</div>
										</div>
										
										
									</div>
								</div>
							</div>
						</div>

					</div>
				</div>
			</div>
			<!-- end wrapper-->
		</div>
	</div>
</template>

<script>
import { schoolAuditOrAreaAudit, TopicDeclarationDetail, getPdfFile } from '@/api/after/schoolAudit.js';
import Breadcrumb from '@/views/backstage/components/Breadcrumb.vue'
export default {
	components:{
		Breadcrumb
	},
	data() {
		return {
			auditForm: {
				declareId: +this.$route.query.topicId,//课题id
				auditId: JSON.parse(sessionStorage.getItem('userInfo')).id,//	审核人id
				auditName: JSON.parse(sessionStorage.getItem('userInfo')).realName,//	审核人名称
				auditType: +this.$route.query.auditType,//	审核类型（0：校审,1:学段审）
				auditState: '',//审核意见
				auditExplain: ''//审核说明
			},
			auditFormRules:{auditState:[{ required: true, message: '请选择审核意见', trigger: 'change' }],	},
			auditExplainRule:[{ required: true, message: '请输入审核说明', trigger: 'blur' }],//审核说明验证
			topicInfo:{},//课题信息
			curFileTitleIndex:0,
			fileTitleList:['课题申请书','匿名评审活页'],
			// isOverTime:false,//当前项目是否超过审核时间
			declarationContents:null,//申报书内容附件
			anonymousReview:null,//匿名评审活页
		};
	},
	filters:{
		getMember(val){
			if (val) {
				return val.replace(/,/g,'、')
			}
		}
	},
	computed:{
		getAllEmcee(){
			if (Object.keys(this.topicInfo).length) {
				if (this.topicInfo.twoEmceeName) {
					return `${this.topicInfo.oneEmceeName}、${this.topicInfo.twoEmceeName}`
				}else{
					return this.topicInfo.oneEmceeName
				}
			}
		}
	},
	created() {
		// 如果没有匿名评审页,那么只渲染课题申请书
		let projectData = JSON.parse(sessionStorage.getItem("projectData"));
		if(projectData.anonymousReviewState==0){
			this.fileTitleList=['课题申请书']
		}
	},
	async mounted() {
		if (this.$route.query.topicId) {
			await this.TopicDeclarationDetail(this.$route.query.topicId)
			//判断当前课题是否超出审核时间
			// if (new Date(this.topicInfo.expectedClosingTime).getTime() < Date.now()) {
			// 	this.isOverTime = true
			// }
			// 数据请求成功之后渲染pdf
			if (Object.keys(this.topicInfo).length) {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
			}
		}
		
	},
	methods:{
		// 课题申报详情
		async TopicDeclarationDetail(id){
			const res = await TopicDeclarationDetail(id)
			if (res.code == 200) {
				console.log('详情',res);
				this.topicInfo = res.data
			}else{
				this.$message.error(res.data)
			}
		},
		// 提交审核
		async schoolAuditOrAreaAudit(){
			const res = await schoolAuditOrAreaAudit(this.auditForm)
			if (res.code == 200) {
				this.$message.success('提交审核成功！')
				this.$router.go(-1)
			}else{
				this.$message.error(res.data)
			}
		},
		// 提交审核结果
		submitAudit(){
			this.$refs.auditFormRef.validate((valid) => {
				if (valid) {
					this.schoolAuditOrAreaAudit();
				} else {
					console.log('error submit!!');
					return false;
				}
			});
		},
		goBack(){
			this.$router.go(-1)
		},
		// 改变文件标题索引
		changeFileTitle(index){
			this.curFileTitleIndex = index
			if (index == 0) {
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.declarationContents}`)
			}else{
				this.$refs.myIframe.contentWindow.location.replace(`${this.uploadUrl}/upload/downloadPdf/${this.topicInfo.anonymousReview}`)
			}
		},
		// 审核意见改变
		auditStateChange(val){
			this.auditExplainRule=val!==1?[{ required: true, message: '请输入审核说明', trigger: 'blur' }]:[]
		}
	}
};
</script>

<style scoped lang="scss">
.view {
	width: 1000px;
	height: 500px;
}
.comments-list{
	margin-top: 20px;
}
.file-list{
	width: 100%;
	display: flex;
	justify-content: center;
	padding-left: 0;
	list-style: none;
	.file-item{
		font-size: 24px;
		text-align: center;
		width: 50%;
		border-bottom: 2px solid #eee;
		cursor: pointer;
	}
}
.file-item.active{
	border-color: #00a2e8;
}
</style>
